// Google Maps API key — Places, Directions, Geocoding
const GOOGLE_API_KEY = 'AIzaSyBWssHGC4J0PqxNbWza5KAXsF5V_g-q0Xg';
// NOTE: 'directions' is NOT a valid Maps JS library name (DirectionsService ships in core).
// Passing it made Google log an "invalid library" warning; we load only 'places'.

let googleMapsLoaded = false;
let googleMapsCallbacks: (() => void)[] = [];

export function loadGoogleMapsScript(callback: () => void) {
  if (typeof window === 'undefined') return;
  const google = (window as any).google;
  if (google?.maps) {
    callback();
    return;
  }

  googleMapsCallbacks.push(callback);
  if (googleMapsLoaded) return;
  googleMapsLoaded = true;

  (window as any).__googleMapsCallback = () => {
    googleMapsCallbacks.forEach((cb) => cb());
    googleMapsCallbacks = [];
  };

  const script = document.createElement('script');
  script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&libraries=places&callback=__googleMapsCallback`;
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
}
